import axios from "axios";
import { API_BASE_URL, getToken } from "../utils/utility";

export default function ServiceController() {
    //> getBanners
    this.getBanners = async function () {
        let result = { isSuccess: true, message: "Success", value: null };
        try {
            const response = await axios.request({
                method: "get",
                maxBodyLength: Infinity,
                url: `${API_BASE_URL}Service/GetBanners`,
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                data: null,
            });
            result.value = response.data;
        } catch (error) {
            result.isSuccess = false;
            result.message = error.toString();
            if (error.response && error.response.status === 401)
                result.message = error.response.data;
        }
        return result;
    };

    //> getRemoteCategories
    this.getRemoteCategories = async function () {
        let result = { isSuccess: true, message: "Success", value: null };
        try {
            const response = await axios.request({
                method: "get",
                maxBodyLength: Infinity,
                url: `${API_BASE_URL}Service/GetRemoteCategories`,
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                data: null,
            });
            result.value = response.data;
        } catch (error) {
            result.isSuccess = false;
            result.message = error.toString();
            if (error.response && error.response.status === 401)
                result.message = error.response.data;
        }
        return result;
    };

    //> getRemoteStores
    this.getRemoteStores = async function (category, tagName) {
        let result = { isSuccess: true, message: "Success", value: null };
        try {
            const response = await axios.request({
                method: "get",
                maxBodyLength: Infinity,
                url: `${API_BASE_URL}Service/GetRemoteStores?category=${category}&tagName=${tagName}`,
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                data: null,
            });
            result.value = response.data;
        } catch (error) {
            result.isSuccess = false;
            result.message = error.toString();
            if (error.response && error.response.status === 401)
                result.message = error.response.data;
        }
        return result;
    };

    //> getRemoteStore
    this.getRemoteStore = async function (code) {
        let result = { isSuccess: true, message: "Success", value: null };
        try {
            const response = await axios.request({
                method: "get",
                maxBodyLength: Infinity,
                url: `${API_BASE_URL}Service/GetRemoteStore?code=${code}`,
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                data: null,
            });
            result.value = response.data;
        } catch (error) {
            result.isSuccess = false;
            result.message = error.toString();
            if (error.response && error.response.status === 401)
                result.message = error.response.data;
        }
        return result;
    };
}
